import styled from "@emotion/styled";
import ErrorSharpIcon from "@mui/icons-material/ErrorSharp";
import {Box, Typography} from "@mui/material";
import {TEAM_DATA} from "data/constants";

export const ModalBox = styled(Box)`
	background: #fff;
	border-radius: 4px;
	color: var(--textColorMain);
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 600px;
	min-width: 320px;
	max-height: 90%;
	overflow: auto;

	@media (max-width: 860px) {
		max-width: 360px;
	}
`;

export const ModalContent = styled(Box)`
	padding: 20px;
`;

export const ModalErrorIcon = styled(ErrorSharpIcon)`
	width: 40px;
	height: 40px;
	margin: 16px auto;
`;

export const ModalTitle = styled(Typography)`
	line-height: 20px;
	color: var(--textColorMain);
`;

ModalTitle.defaultProps = {
	variant: "h3",
};

export const ModalDescription = styled(Typography)`
	color: var(--textColorMain);
	margin: 20px auto;
	text-align: center;
`;

ModalDescription.defaultProps = {
	variant: "body1",
	fontWeight: "regular",
};

export const ModalIconCloseButtonPosition = styled.div`
	position: absolute;
	right: 5px;
	top: 5px;
`;

export const ModalContentCustom = styled(ModalContent)`
	padding: 35px 20px;

	button {
		svg {
			path {
				color: #2b2b2b;
			}
		}
	}
`;
export const ModalHeader = styled(Box)`
	width: 100%;
	min-height: 200px;
	background: url(${TEAM_DATA.background}) no-repeat center center;
	background-size: cover;
	display: flex;
	justify-content: center;
	align-items: center;
	position: sticky;
	top: 0;
	z-index: 1;
`;
